import { Box, FormHelperText } from '@mui/material';

import { Text } from 'common';

export function Hl7MessageEventFormFields() {
  return (
    <Box>
      <Text>No configuration required</Text>
      <FormHelperText>Extract HL7 message event from Notable databases.</FormHelperText>
    </Box>
  );
}
